import { IAppState } from '../../common/state';

export function getAddress({ newbuildingInformation }: IAppState): string | null {
  return newbuildingInformation?.address || null;
}
